import find from 'lodash/find'
import globalStore from '@/globalStore'
import { MANAGEMENT_SIDER_MENUS } from '@/layouts/components/Main/constant'

const useAuthorized = (code: string) => {
  const { authorizedMenus, authorizedButtons } = globalStore
  const isPersonal = globalStore.getIsPersonal()

  /**
   * 检查权限
   * @param list
   * @returns
   */
  const checkPermission = (list: any) => {
    if (isPersonal) {
      // 个人账号
      if (MANAGEMENT_SIDER_MENUS.map(m => m.code).includes(code)) {
        // 主体相关路由个人账号无访问权限
        return false
      }
      return true
    }
    // 个人主体及企业
    const item = find(list, (f: any) => f.code === code)
    if (item) {
      return !!item?.hasPermission
    }
    return true
  }

  return {
    hasPermission: checkPermission(authorizedMenus.concat(authorizedButtons)),
    menuList: authorizedMenus,
    buttonList: authorizedButtons,
  }
}

export default useAuthorized
